import React from "react"
import {
  CloudUploadIcon,
  CogIcon,
  LockClosedIcon,
  RefreshIcon,
  ServerIcon,
  ShieldCheckIcon,
} from "@heroicons/react/outline"
import RG from "../commonfuction/Overslider"
import Support from "../OBGettingStartedPage/Support"
import Publications from "../OBGettingStartedPage/Publications"

const features = [
  {
    name: <RG />,
    content:
      "The one stop location for quick links, shortcuts, and other OneBill resource materials.",
    icon: CloudUploadIcon,
  },
  {
    name: "FAQs",
    content: "Frequently asked questions and answers",
    icon: LockClosedIcon,
  },
  {
    name: "Support",
    content: "Contact us for more detailed support",
    icon: RefreshIcon,
  },
  {
    name: "Quickstart Guide",
    content: "To get started with the fundamentals of OneBill.",
    icon: ShieldCheckIcon,
  },
  {
    name: "Product Documentation",
    content:
      "For all screen, operations, use case, and platform related information.",
    icon: CogIcon,
  },
  {
    name: "API Reference Guide",
    content:
      "The complete guide to OneBill web services. References, payloads, sample requests, and more",
    icon: ServerIcon,
  },
  {
    name: "Training Guide",
    content: "Contact us for more detailed support",
    icon: ServerIcon,
  },
]

function Landing() {
  return (
    <>
      <div className="relative bg-white py-16 sm:py-24 lg:py-32">
        <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
          <h2 className="text-base font-semibold tracking-wider text-indigo-600 uppercase">
            ONEBILL
          </h2>
          <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
            End-to-end revenue management solution
          </p>
          <p className="mt-5 max-w-prose mx-auto text-xl text-gray-500">
            OneBill is an advanced end-to-end revenue management solution
            designed to efficiently manage and boost your billing operations.
          </p>
          <div className="mt-12">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
              {features.map(feature => (
                <div key={feature.name} className="pt-6">
                  <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8">
                    <div className="-mt-6">
                      <div>
                        <span className="inline-flex items-center justify-center p-3 bg-red-500 rounded-md shadow-lg">
                          <feature.icon
                            className="h-6 w-6 text-white"
                            aria-hidden="true"
                          />
                        </span>
                      </div>
                      <h3 className="mt-8 text-lg font-medium text-indigo-700 hover:text-indigo-800 tracking-tight">
                        {feature.name}
                      </h3>
                      <p className="mt-5 text-base text-gray-500">
                        {feature.content}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Support />
      <Publications />
    </>
  )
}

export default Landing
